import type { BlogSection } from './types';

export type BlogReference = {
  credit: string;
  title: string;
  publication: string;
  href: string;
  companion?: { label: string; href: string };
};

export function slugifyBlogAnchor(value: string): string {
  return value.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '');
}

export function blogCitation(number: number): string {
  return `<sup id="cite-${number}" class="ml-0.5 scroll-mt-28 font-mono text-[0.68em] leading-none"><a href="#ref-${number}" aria-label="Reference ${number}" class="text-foreground-secondary no-underline hover:text-foreground">[${number}]</a></sup>`;
}

export function blogFigureLink(number: number): string {
  return `<a href="#figure-${number}" class="font-medium text-foreground underline decoration-foreground/20 underline-offset-4 hover:text-brand-mint">Figure ${number}</a>`;
}

export function blogReferenceList(items: BlogReference[]): BlogSection {
  return {
    type: 'html',
    content: `<ol class="list-decimal space-y-4 pl-6 text-[14px] leading-6 text-foreground-muted sm:text-[15px]">${items.map((item, index) => {
      const number = index + 1;
      const companion = item.companion
        ? ` See also the <a href="${item.companion.href}" target="_blank" rel="noreferrer" class="text-foreground-secondary underline underline-offset-4 hover:text-foreground">${item.companion.label}</a>.`
        : '';
      return `<li id="ref-${number}" class="scroll-mt-28"><span class="text-foreground-secondary">${item.credit}.</span> <a href="${item.href}" target="_blank" rel="noreferrer" class="font-medium text-foreground underline decoration-foreground/25 underline-offset-4 hover:text-brand-mint">${item.title}</a>. <span>${item.publication}.</span>${companion} <a href="#cite-${number}" aria-label="Return to citation ${number}" class="ml-1 font-mono text-foreground-secondary no-underline hover:text-foreground">↩</a></li>`;
    }).join('')}</ol>`,
  };
}
